import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";
import ls from "util/secureStorage";
// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const arbitraryApi = createApi({
  reducerPath: "arbitrary",
  tagTypes: [],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_WALLET_API_ENDPOINT}`,
    prepareHeaders: (headers, _) => {
      // const token = localStorage.getItem("tokenset");
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      console.log("FROM ARBITRARY API :: ", { token: auth.token });

      headers.set("Authorization", auth.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: () => wrapBaseApi(`/countries`),
      transformResponse: (res) => res?.data,
    }),
    getCookieByPass: builder.query({
      query: () => wrapBaseApi(`/auth/bypass`),
      transformResponse: (res) => res?.data,
    }),
    getReferrals: builder.query({
      query: (id) => wrapBaseApi(`/account/referrals?refBy=${id}`),
      // query: (id) => `/wallet/earning?userId=${id}&source=referrals`,
      transformResponse: (res) => res?.data,
    }),
    getReferralTrades: builder.query({
      query: (id) => wrapBaseApi(`/wallet/earning?refBy=${id}&earned=true`),
      // query: (id) => wrapBaseApi(`/wallet/earning?userId=${id}&source=referrals`),
      transformResponse: (res) => res?.data,
    }),
    getReferralEarnings: builder.query({
      query: (id) => wrapBaseApi(`/wallet/earning?referredUserId=${id}`),
      // query: (id) => wrapBaseApi(`/wallet/earning?userId=${id}&source=referrals`),
      transformResponse: (res) => res?.data,
    }),
    claimRewards: builder.mutation({
      query: (input) => ({
        // url: `/v2/auth/signup`,
        url: wrapBaseApi(`/account/rewards/claim`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    signUp: builder.mutation({
      query: (input) => ({
        // url: `/v2/auth/signup`,
        url: wrapBaseApi(`/v2/auth/signup${input?.refCode ? `?refCode=${input.refCode}` : ""}`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    resetPassword: builder.mutation({
      query: ({ params, ...input }) => ({
        url: wrapBaseApi(`/auth/resetPassword?${params}`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    reset2FA: builder.mutation({
      query: ({ params, ...input }) => ({
        url: wrapBaseApi(`/auth/reset2FA?${params}`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    forgotPassword: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/forgotPassword`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res.data,
    }),
    signUpViaSocial: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/social/verifyId`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    verify2fa: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/2fa/verifyUser`),
        method: "POST",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    verifyEmail: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/verifyEmail?humanKey=${input.captcha}`),
        method: "POST",
        body: { code: input.code },
      }),
      transformResponse: (res) => res?.data,
    }),
    verifyPhone: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/verifyPhone?humanKey=${input.captcha}`),
        method: "POST",
        body: { code: input.code },
      }),
      transformResponse: (res) => res?.data,
    }),
    resendEmailPin: builder.mutation({
      query: (captcha) => ({
        url: wrapBaseApi(`/auth/verifyEmail?humanKey=${captcha}`),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    resendPhonePin: builder.mutation({
      query: (captcha) => ({
        url: wrapBaseApi(`/auth/verifyPhone?humanKey=${captcha}`),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
    patchPhoneNumber: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/patch/phone`),
        method: "PUT",
        body: input,
      }),
      transformResponse: (res) => res?.data,
    }),
    generate2fa: builder.mutation({
      query: () => ({
        url: wrapBaseApi(`/auth/2fa/generate`),
        method: "POST",
        body: {},
      }),
      transformResponse: (res) => res?.data,
    }),
    enable2fa: builder.mutation({
      query: () => ({
        url: wrapBaseApi(`/auth/2fa/turnOnTwoFa`),
        method: "PUT",
        body: {},
      }),
      transformResponse: (res) => res?.data,
    }),
    verifyEmail2: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/verify-email?humanKey=${input.captcha}`),
        method: "POST",
        body: { code: input.code },
      }),
      transformResponse: (res) => res?.data,
    }),
    verifyPhone2: builder.mutation({
      query: (input) => ({
        url: wrapBaseApi(`/auth/verify-phone?humanKey=${input.captcha}`),
        method: "POST",
        body: { code: input.code },
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCountriesQuery,
  useGetCookieByPassQuery,
  useGetReferralsQuery,
  useGetReferralEarningsQuery,
  useGetReferralTradesQuery,
  useSignUpMutation,
  useClaimRewardsMutation,
  useVerify2faMutation,
  useVerifyEmailMutation,
  useResendEmailPinMutation,
  useSignUpViaSocialMutation,
  usePatchPhoneNumberMutation,
  useResendPhonePinMutation,
  useVerifyPhoneMutation,
  useEnable2faMutation,
  useGenerate2faMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useReset2FAMutation,
} = arbitraryApi;

export default arbitraryApi;
